<template>
  <div>
    <Modal v-model="isShow" @on-ok="ok" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">周边配套</h3>
      <Row class="row" >
        <Col span="2"><font style="color: #ed4014;">*</font>排序</Col>
        <Col span="6"><font style="color: #ed4014;">*</font>配套设施</Col>
        <Col span="12"><font style="color: #ed4014;">*</font>描述</Col>
        <Col span="2">图片</Col>
        <Col span="2">操作</Col>
      </Row>
      <Row class="row" v-for="(item,index) in data " :key="item.fid">
        <Col span="2">
          <Input class="width50"  v-model="item.labelOrder" />
        </Col>
        <Col span="6">
          <Input class="width80" v-model="item.labelName"/>
        </Col>
        <Col span="12">
          <Input class="width200" v-model="item.remark"/>
        </Col>
        <Col span="2">
          <span v-if="!item.fid">-</span>
          <a v-else @click.stop="uploadImg(item)">配置</a>
        </Col>
        <Col span="2">
          <a @click.stop="deleteItem(item,index)">删除</a>
        </Col>
      </Row>
      <div class="mt20">
        <a @click.stop="addItem">+ 添加</a>
      </div>
      <img-upload :n="uploadN" :fid="configFid" :orderId="orderId" @pic="pic" :maxnum="1"></img-upload>
      <!--<div slot="footer"></div>-->
    </Modal>
  </div>
</template>

<script>
  import ImgUpload from './ImgUpload'
  import {labellist,labeledit,labelremove} from "../../../../api/projectConfig";
  import {isType} from "../../../../utils/public";

  export default {
    name: "Kangfang",
    components:{
      ImgUpload
    },
    props:{
      n: {
        type: Number,
        default: 0
      },
      fid:{
        type:String,
        default:''
      }
    },
    watch:{
      n(){
        this.labellist()
        this.isShow=true
      },
    },
    data(){
      return {
        isShow:false,
        loading:true,
        uploadN:0,
        orderId:0,
        configFid:'',
        data:[]
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      addItem(){
        let order=1
        if(this.data.length > 0){
          order = this.data[this.data.length-1].labelOrder;
          if((+order).toString()==='NaN' || !isType('Number',+order)){
            order = this.data.length+1;
          }else{
            order = parseInt(order)+1;
          }
        }
        this.data.push({
          "fid": "",
          "labelOrder": order,
          "labelName": "",
          "remark": "",
          "labelType": 7,
          "moduleId": ""
        })
      },
      labellist(){
        if(!this.fid){
          return
        }
        let params={
          moduleFid:this.fid,
          type:7
        }
        labellist(params).then(res=>{
          this.data=res.data
        })

      },
      uploadImg(item){
        this.configFid=item.fid
        this.uploadN++
      },

      deleteItem(item,index){

        this.$Modal.confirm({
          content: '<p>确认删除？</p>',
          onOk: () => {
            if(item.fid){
              let params={
                fid:item.fid
              }
              labelremove(params).then(res=>{
                this.$Message.success('删除成功')
                this.labellist()
              })
            }
            else {
              this.data.splice(index,1)
            }
          }
        })
      },
      ok(){
        if(this.data.length < 1){
          this.changeLoading()
          this.isShow = false
          return
        }
        let a1=[]
        let isNull=false
        let isnotNumber=false
        let isOverLength=false

        this.data.forEach(ele=>{
          if(!ele.labelName || !ele.labelOrder || !ele.remark){
            isNull=true
            return
          }

          if((+ele.labelOrder).toString()==='NaN' || !isType('Number',+ele.labelOrder)){
            isnotNumber=true
            return
          }else{
            if(ele.labelOrder <= 0){
              isnotNumber=true
              return
            }
          }
          a1.push(ele.labelOrder+'')
          if(ele.labelName.length > 10 || ele.remark.length > 200){
            isOverLength = true
            return
          }
        })

        if(isNull){
          this.$Message.info('请检查必填项')
          this.changeLoading()
          return
        }

        if(isnotNumber){
          this.$Message.info('排序必须为数字,且不能小于等于0')
          this.changeLoading()
          return
        }

        let a2=new Set(a1)
        if(a1.length!== a2.size){
          this.$Message.info('排序不能重复')
          this.changeLoading()
          return
        }
        if(isOverLength){
          this.$Message.info('配套设施字数不能超过10个，描述字数不能超过200')
          this.changeLoading()
          return
        }
        let params={
          moduleFid:this.fid,
          labelEntities:this.data,
          proHouseTypeFid:this.projectFid,
          type:1
        }
        labeledit(params).then(res=>{
          this.$Message.success('周边配套保存成功')
          this.changeLoading()
          this.isShow = false
        }).catch(error=>{})
      },
      pic(data){
        if(data.length < 1){
          return
        }
        var order = data[0].order
        let labelOrder = this.data.filter(item => {return item.labelOrder==order})
        data.forEach(item => {
          labelOrder[0].picUrl.push(item)
        })
      }

    },
    created(){
      // this.labellist()
    }
  }
</script>
<style scoped>
.width50{
  width: 50px;
}
.width80{
  width: 80px;
}
.width200{
  width: 200px;
}

.row {
  text-align: center;
  /*margin-bottom: 10px;*/
  line-height: 32px;

  border-left: 1px solid rgb(222, 222, 222);
  border-right: 1px solid rgb(222, 222, 222);
  border-bottom: 1px solid rgb(222, 222, 222);
  padding: 7px;
}

.row:first-child {
  border-top: 1px solid rgb(222, 222, 222);
  background-color: rgb(248, 248, 248);
  padding: 5px;
}
</style>
